// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"294":"72c8b010","426":"aef4f8d4","787":"f95108ff","794":"46e224e5"}[chunkId] + ".chunk.js";
};